export enum DownloadTypes {
  DOWNLOAD_BROCHURE = "Download brochure",
  APPLY_NOW = "Apply now",
  APPLY_NOW_CTA = "Apply now CTA",
  USE_CTA_LINK_1 = "Use CTA Link 1",
}

export default DownloadTypes;
